import React, {Component} from "react";
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

// import EditIcon from '@material-ui/icons/Create';
//Component
//Reducer

const styles = theme => ({
    avatar: {
        margin: 0,
        width: 16,
        height:16,
        textAlign : 'center'
    },
})

class CategoryIconRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false,
            name : this.props.data.name
        }
    }

    renderData  = () => {
        
    }
    render() {
        const { classes } = this.props;

        let path = "/img/_hz_"+this.props.data.category+".png";
        return  (<img alt={this.props.data.category} src={path} className={classes.avatar} />)
        
        /*return (
            <div>{this.renderData()}
                {this.props.data.category=='share' ? '🚫' : '' }
                {this.props.data.category=='warning' ? '❗' : '' }
                {this.props.data.category=='prohibit' ? '⚠️' : '' }
            </div>
        );*/
    }
};

const mapStateToProps = function(state,ownProps) {
    return {
        ...ownProps
    }
};

const mapActionsToProps =  {

};
const enhance = compose(
    connect(
        mapStateToProps,
        mapActionsToProps
    ),
    withStyles(styles)
);  

export default enhance(CategoryIconRenderer)
